import { IS_MOCK_MODE } from 'src/constants/featureFlag'
import { SERVER_URL } from 'src/constants/serverUrl'
import { requestDelete } from 'src/legacy_modules/server/request'

export const submitDelete = async ({
  trialUid,
  templateUid,
}: {
  trialUid: string
  templateUid: string
}): Promise<{}> => {
  if (IS_MOCK_MODE) {
    return {}
  }

  await requestDelete<{}>({
    url: `${SERVER_URL}/trials/${trialUid}/templates/${templateUid}`,
    params: {},
  })

  return {}
}
